import React, { useState, useEffect } from 'react';
import AgentsCockpit from './AgentsCockpit';
import AgentConfigPanel from '../../../platform/components/AgentConfigPanel';
import { canAdminTenant, callWorkGateway } from './shell/workGateway';

/**
 * AgentsHome — thin route wrapper for the unified Agents cockpit (CHA-273,
 * supersedes the per-agent YuliePage/EllaPage tabs from CHA-135/CHA-145).
 *
 * Deep-linkable sub-routes map to a cockpit filter (routes preserved):
 *   #/agents          → All
 *   #/agents/yulie    → Yulie-filtered
 *   #/agents/ella     → Ella-filtered
 *
 * The `agentTickets` view model is passed down from InMoceanDashboard (the
 * single useAgentTickets subscription) — this wrapper adds no data fetching.
 */
const AGENT_KEYS = ['yulie', 'ella'];

// Parse the cockpit filter out of the hash (#/agents/<key>). Defaults to 'all'.
function filterFromHash() {
  const hash = window.location.hash.replace('#/', '').replace('#', '');
  const seg = hash.split('/')[1];
  return AGENT_KEYS.includes(seg) ? seg : 'all';
}

export default function AgentsHome({ agentTickets, userProfile }) {
  const [filter, setFilter] = useState(filterFromHash);

  useEffect(() => {
    const onHashChange = () => setFilter(filterFromHash());
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // CHA-587 (W6) — the COO sees and edits Yulie/Ella's config here; admins only (server-enforced too).
  return (
    <div className="space-y-4">
      {canAdminTenant(userProfile) && <AgentConfigPanel call={callWorkGateway} />}
      <AgentsCockpit agentTickets={agentTickets} initialFilter={filter} />
    </div>
  );
}
